<template>
  <div>
    <div class="wc-password-input">
      <WCInput
        autocomplete="current-password"
        :type="passwordInputType"
        :state="vuelidateObject.$error ? 'invalid' : null"
        @input="vuelidateObject.$touch()"
        @focus="passwordActive = true"
        v-model="_model"
        v-on="listeners"
        v-bind="$attrs"
      />

      <!--Warning Icon-->
      <button
        type="button"
        :aria-label="$t('invalidField')"
        ref="wc-password-input__warning-icon-overlay"
        class="unstyled-btn wc-password-input__warning-icon-overlay"
      ></button>
      <WCToolTip
        target="wc-password-input__warning-icon-overlay"
        position="right"
        :delay-millis="500"
      >
        {{ $t('passwordRequired') }}
      </WCToolTip>

      <!--Eye Icon-->
      <button
        class="unstyled-btn wc-password-input__eye-icon"
        ref="wc-password-input__eye-icon"
        @click="togglePasswordHidden"
        :aria-label="passwordIconTitle"
        type="button"
      >
        <font-awesome-icon class="text-muted" :icon="passwordIcon" />
      </button>
      <WCToolTip target="wc-password-input__eye-icon" position="right" :delay-millis="500">
        {{ $t('showHidePassword') }}
      </WCToolTip>
    </div>
  </div>
</template>

<script>
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCToolTip from '@/components/WCToolTip/WCToolTip.vue';

export default {
  name: 'WCPasswordInput',
  components: { WCToolTip, WCInput },
  inheritAttrs: false,
  props: {
    value: {},
    vuelidateObject: {
      type: Object,
      required: true,
    },
  },
  computed: {
    passwordInputType() {
      return this.passwordHidden ? 'password' : 'text';
    },
    passwordIcon() {
      return this.passwordHidden ? 'eye' : 'eye-slash';
    },
    passwordIconTitle() {
      return this.passwordHidden ? this.$t('showPassword') : this.$t('hidePassword');
    },
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    _model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    togglePasswordHidden() {
      this.passwordHidden = !this.passwordHidden;
    },
  },
  data() {
    return {
      passwordActive: false,
      passwordHidden: true,
    };
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-password-input {
  position: relative;

  // WC-380: Hide the Microsoft Edge "Show Password" icon
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  .wc-password-input__warning-icon-overlay {
    display: none;
  }

  // Shift the (i) warning icon left
  ::v-deep .form-control.is-invalid {
    background-position: calc(100% - 2rem) !important;

    // Position a pseudo element over the (i) icon to anchor a tooltip
    + .wc-password-input__warning-icon-overlay {
      display: block;
      height: 1rem;
      width: 1rem;
      position: absolute;
      top: calc(50% - 0.5rem);
      right: 2.1rem;
    }
  }

  // Size and position the eye icon
  .wc-password-input__eye-icon {
    position: absolute;
    width: 1.6rem;
    top: calc(50% - 0.75rem);
    right: 0.5rem;
  }
}
</style>
